<template>
    <div class="row no-gutters">
        <loading :active.sync="isLoading" :is-full-page="false"></loading>
        <div class="col-lg-12 h-inherit">
            <div class="align-center h-inherit">
                <div class="row no-gutters mt-2">
                    <div class="col-xl-6 col-lg-12">
                        <h5 class="card-title text-center">
                            {{ $t('UI_CHAPTERING_CHAPTER') }}
                        </h5>
                        <EventColumn :event-list="$store.getters.events.chapter" v-if="$store.getters.events" type="chapter"/>
                        <button class="btn mt-2" @click="newEvent.isChapter = true; $refs.addEventModal.open();"
                                v-if="editModeEnabled">
                            <i class="fa fa-plus"></i> {{ $t('UI_INSTANCE_EVENT_ADD') }}
                        </button>
                    </div>
                    <div class="col-xl-6 col-lg-12">
                        <h5 class="card-title text-center">
                            {{ $t('UI_CHAPTERING_ENTRY') }}
                        </h5>
                        <EventColumn :event-list="$store.getters.events.entry" type="entry" v-if="$store.getters.events"/>
                        <button class="btn mt-2" @click="newEvent.isChapter = false; $refs.addEventModal.open();"
                                v-if="editModeEnabled">
                            <i class="fa fa-plus"></i> {{ $t('UI_INSTANCE_EVENT_ADD') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>


        <!-- Add Event Modal-->
        <sweet-modal :title="$t('UI_INSTANCE_EVENT_ADD_MODAL_TITLE')" ref="addEventModal" class="text-left"
                     v-on:close="onAddEventModalClose">
            <div class="form-group">
                <label for="name">{{ $t('UI_INSTANCE_EVENT_ADD_MODAL_EVENT_NAME') }}</label>
                <input type="text" id="name" v-model="newEvent.name"
                       :placeholder="$t('UI_INSTANCE_EVENT_ADD_MODAL_EVENT_NAME')" class="form-control" v-on:keyup.enter="addEvent">
            </div>

            {{ $t('UI_INSTANCE_EVENT_ADD_MODAL_EVENT_TYPE') }}
            <div class="form-check">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input" v-model="newEvent.isChapter" value="true"> {{
                    $t('UI_CHAPTERING_CHAPTER') }}
                </label>
            </div>
            <div class="form-check">
                <label class="form-check-label">
                    <input type="radio" class="form-check-input" v-model="newEvent.isChapter" value="false"> {{
                    $t('UI_CHAPTERING_ENTRY') }}
                </label>
            </div>

            <div slot="button">
                <button class="btn btn-primary" @click="addEvent">
                    {{ $t('UI_MODAL_BUTTON_CREATE') }}
                </button>
                <button class="btn btn-secondary ml-1" @click="$refs.addEventModal.close()">
                    {{ $t('UI_MODAL_BUTTON_CLOSE') }}
                </button>
            </div>
        </sweet-modal>

    </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import { SweetModal } from 'sweet-modal-vue';
import { RepositoryFactory } from '../../../../../../repositories/RepositoryFactory';
import EventColumn from './EventColumn';

const EventRepository = RepositoryFactory.get('events');

export default {
  name: 'EventPanel',
  components: {
    EventColumn,
    Loading,
    SweetModal,
  },
  data() {
    return {
      isLoading: false,
      newEvent: {
        name: '',
        isChapter: true,
      },
    };
  },
  mounted() {
    this.listEvents();
  },
  computed: {
    editModeEnabled() {
      return this.$store.getters.instanceGroupEditEnabled;
    },
  },
  methods: {
    addEvent() {
      if (this.newEvent.name === '') {
        this.$snotify.error(this.$t('UI_INSTANCE_EVENT_NAME_EMPTY'));
        return false;
      }
      EventRepository.add(this.newEvent.name, this.newEvent.isChapter)
        .then((res) => {
          this.$snotify.info(this.$t('UI_INSTANCE_EVENT_ADDED', { name: this.newEvent.name }));
          EventRepository.refetchList();
          this.$refs.addEventModal.close();
        });
    },
    onAddEventModalClose() {
      this.newEvent.name = '';
      this.newEvent.isChapter = true;
    },
    async listEvents() {
      this.isLoading = true;
      await EventRepository.list()
        .then((response) => {
          this.isLoading = false;
          this.$store.commit('setEvents', response.data.list);
        });
    },
  },
};
</script>

<style scoped>

</style>
